import { createContext, useContext } from 'react';
import { Label, PackCopyWithLanguages, Project, UserDetails } from '../types';

// Your existing state interface
export interface ProjectDetailsState {
    project: Project | null;
    labels: Label[];
    labelThumbnailUrls: Record<string, string>;
    packCopies: PackCopyWithLanguages[];
    loadingState: 'loading' | 'loaded' | 'error';
    errorMessage: string | null;
    userDetailsMapping: { [user_id: string]: UserDetails | null };
}

export interface ProjectDetailsHandlers {
    handlePackCopyDuplicate: (packCopyId: string) => Promise<void>;
    handlePackCopyDelete: (packCopyId: string) => Promise<void>;
    handleLabelDelete: (labelId: string) => Promise<void>;
}

// Update the context to include both state and setters
export interface ProjectDetailsContextType {
    state: ProjectDetailsState;
    handlers: ProjectDetailsHandlers;
    refresh: (showSpinner?: boolean) => Promise<void>;
}

export const ProjectDetailsContext =
    createContext<ProjectDetailsContextType | null>(null);

export function useProjectDetailsContext() {
    const projectDetailsContext = useContext(ProjectDetailsContext);

    if (projectDetailsContext === null) {
        throw new Error(
            'useProjectDetailsContext must be used with a ProjectDetailsContext',
        );
    }

    return projectDetailsContext;
}
